export default {"src":"/login-app/[GIT_HASH]/_next/static/media/description.885a2c74.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};